<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        class="mt-2"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        class="mt-2"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ command.responseData.hardware.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Model:
              {{ command.responseData.hardware.hardware_model.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div class="mt-6">
          <p>
            ดาวน์โหลดไฟล์
            <a
              :href="command.responseData.response_json.url_device_log"
              download="device_log.zip"
              >device_log.zip</a
            >
          </p>
        </div>
      </div>
      <div v-if="command.status === 'fail'">
        <v-list-item
          two-line
          v-for="(value, key) in command.responseData"
          :key="key"
        >
          <v-list-item-content>
            <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
            <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
              {{ value }}
            </p>
          </v-list-item-content>
        </v-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
    }
  },

  async mounted() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_model: this.hardware.hardware_model.hardware_model_code,
        body: {
          hardware_uuid: this.hardware.hardware_uuid,
          data: null,
        },
      }

      const deviceLogData = await this.getDeviceLog(payload)

      this.command = {
        status: 'connect',
        date: deviceLogData.create_datetime,
      }
      this.syncJob(deviceLogData.sync_job_uuid)
    } catch (error) {
      if (error.response && error.response.data) {
        this.command = {
          status: 'fail',
          date: new Date(),
          responseData: {
            Type: 'Get Device Log File Fail',
            Message: error.response.data.message || 'Error',
          },
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getDeviceLog: 'hardware/getDeviceLog',
      fetchJob: 'hardware/fetchJob',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        this.command = {
          status: 'success',
          date: res.done_datetime,
          responseData: res,
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.done_datetime && !res.is_response_success) {
        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
